export default __webpack_public_path__ + "static/caligrakids-e3c447adda5858d35269cd99f8e182ff.otf";